  export enum FileUploadStatus {
    Failed,
    Succeeded,
    Pending
  }